/**
 * O payload de fio do ROTEIRO (`select_multi_leg_fares`), num lugar só.
 *
 * Existe para encodar UM trap onde o compilador consegue ajudar. `MultiLegPickSchema`
 * é `.strict()` e o pick do explorer (`ExplorerConfirm` do tipo `multi`) carrega
 * `price`, que o fio NÃO tem. Espalhar o pick (`...leg`) compila, passa em qualquer
 * teste que não valide contra o schema, e quebra só em produção: o `safeParse` do
 * `submit_guard` falha, o payload escorrega pro fallthrough de `submit_checkout` e a
 * pessoa recebe "não entendi" com o card já queimado. Projetar campo a campo é a
 * única forma de a checagem de tipo pegar isso.
 *
 * Dois hosts emitem esse payload — o card do roteiro (`flight_multi_offers`) e o card
 * binário quando a pessoa vira a aba pra Multitrechos na faixa do explorer — e é por
 * isso que o helper mora em `shared/`, não dentro de um deles.
 */

import type { FlightMultiLegFareSelection } from '@voll-intelligence/genui-contract';

/** O mínimo que o fio precisa de cada trecho. Aceita qualquer pick que os tenha
 *  (o do explorer traz `price` a mais; o do card, nada a mais) — e descarta o
 *  resto por projeção. */
export interface MultiLegWirePick {
  legIndex: number;
  offerId: string;
  fareId: string;
}

export function multiLegSelectionOf(
  picks: readonly MultiLegWirePick[],
): FlightMultiLegFareSelection {
  return {
    action: 'select_multi_leg_fares',
    legs: picks.map((pick) => ({
      legIndex: pick.legIndex,
      offerId: pick.offerId,
      fareId: pick.fareId,
    })),
  };
}
